import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { ClientDetailsContainer } from '@/features/call-center/ClientDetails/ClientDetailsContainer'
import { type CallCenterCustomerLookupViewModel } from '@/features/call-center/CallCenterCustomerLookupViewModel'
import { CustomerLookupSection } from '@/features/call-center/CustomerLookupSection'

export interface CustomerLookupSectionContainerProps {
  vm: CallCenterCustomerLookupViewModel
  onAddClient: () => void
  onAddToWorkspace: () => void
}

export const CustomerLookupSectionContainer = observer(
  function CustomerLookupSectionContainer({
    vm,
    onAddClient,
    onAddToWorkspace,
  }: CustomerLookupSectionContainerProps) {
    return (
      <CustomerLookupSection
        searchText={vm.searchText.value}
        onSearchTextChange={vm.searchText.change}
        onSubmitSearch={vm.submitSearch}
        showAddClientButton={!!vm.showAddClientButton}
        onAddClient={onAddClient}
        isSearching={!!vm.isSearching}
        showEmptyState={!!vm.shouldShowEmptyState}
        hasLastQuery={!!vm.lastQuery}
        showResults={vm.results.length > 0 || !!vm.shouldShowResultsLoader}
        results={vm.resultVms.map((resultVm) => ({
          key: resultVm.result.key,
          displayName: resultVm.displayName,
          email: resultVm.email,
          phoneNumber: resultVm.phoneNumber,
          active: resultVm.isSelected,
          onSelect: resultVm.select,
        }))}
        resultsLoader={
          vm.shouldShowResultsLoader && (
            <InfiniteScrollLoaderContainer
              scrollProvider={vm.scroller}
              compact
            />
          )
        }
        hasSelection={!!vm.callCenterSelectionVm.hasSelection}
        details={
          <ClientDetailsContainer
            vm={vm.callCenterSelectionVm}
            jobHistoryVm={vm.callCenterJobHistoryVm}
            onAddToWorkspace={onAddToWorkspace}
          />
        }
      />
    )
  },
)
